/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconShield = createReactComponent("shield", "IconShield", [
  [
    "path",
    {
      d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3",
      key: "svg-0"
    }
  ]
]);

export { IconShield as default };
//# sourceMappingURL=IconShield.js.map
